module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/mv_img03-02eccaff034502758b7b7023f93bdb00.png";